import { Box } from '@mui/material'
import React from 'react'

export default function BGContainer({ children, sx = {}, id, maxWidth }) {
    return (
        <Box id={id} maxWidth={maxWidth} sx={{
            width: '100%', display: 'flex', flexDirection: 'column', position: 'relative',
            overflow: 'hidden', mx: 'auto', ...sx
        }}>
            {children}
        </Box>
    )
}
